import { defineStore } from "pinia"
import { ref, type Ref } from "vue"
import { Project } from "@/models/project.model"

export const useProjectStore = defineStore("projectsStore", () => {
  const projects: Ref<Project[]> = ref([])

  return {
    projects
  }
})
